import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import TributoService from 'business/cadastro/fiscal/tributo/tributoService'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import GridForm from 'base/GridForm'
import ControllerInput from 'base/ControllerInput'
import { TabPanel, TabView } from 'primereact/tabview'
import { createCodeDescriptionObject } from 'helper/formater'
import { defaultEmptySelection } from 'helper/default'
import EsferaService from 'business/cadastro/fiscal/esfera/esferaService'
import TabelaCstService from 'business/cadastro/fiscal/tabelaCst/tabelaCstService'
import TipoTributoService from 'business/cadastro/fiscal/tipoTributo/tipoTributoService'
import { errorToToast } from 'helper/error'

export default function Tributo() {

    const [service] = useState(() => new TributoService())
    const [esferas, setEsferas] = useState([])
    const [tipoTributos, setTipoTributos] = useState([])
    const [tabelaCsts, setTabelaCsts] = useState([])
    const [validations, setValidations] = useState([])

    const toast = useRef(null)
    const stepperRef = useRef(null)
    const { id } = useParams()

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.esfera) {
            setEsferas([createCodeDescriptionObject(data.esfera, 'codigo_esf', 'descricao_esf')])
        } else if (data?.cod_esf_tri) {
            setEsferas([{ codigo_esf: data.cod_esf_tri, descricao_esf: data.cod_esf_tri }])
        }

        if (data?.tabela_cst) {
            setTabelaCsts([createCodeDescriptionObject(data.tabela_cst, 'codigo_tabcst', 'descricao_tabcst')])
        } else if (data?.cod_tabcst_tri) {
            setTabelaCsts([{ codigo_tabcst: data.cod_tabcst_tri, descricao_tabcst: data.cod_tabcst_tri }])
        }

        if (data?.tipo_tributo) {
            setTipoTributos([createCodeDescriptionObject(data.tipo_tributo, 'codigo_tiptri', 'descricao_tiptri')])
        } else if (data?.cod_tiptri_tri) {
            setTipoTributos([{ codigo_tiptri: data.cod_tiptri_tri, descricao_tiptri: data.cod_tiptri_tri }])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(schema => setValidations(schema))
    }, [service])

    const loadEsferas = async () => {
        const esferaService = new EsferaService()
        await esferaService.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_esf', 'descricao_esf'))
            options.push({ codigo_esf: null, descricao_esf: defaultEmptySelection() })
            setEsferas(options)
        }).catch(err => errorToToast({ err, toast, alt: 'Não foi possível carregar as esferas.' }))
    }

    const loadTipoTributos = async () => {
        const tipoTributoService = new TipoTributoService()
        try {
            const rs = await tipoTributoService.list('')
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tiptri', 'descricao_tiptri'))
            options.push({ codigo_tiptri: null, descricao_tiptri: defaultEmptySelection() })
            setTipoTributos(options)
        } catch (err) {
            errorToToast({ err, toast, alt: 'Não foi possível carregar os tipos de tributo.' })
            setTipoTributos([{ codigo_tiptri: null, descricao_tiptri: defaultEmptySelection() }])
        }
    }

    const loadTabelaCsts = async () => {
        const tabelaCstService = new TabelaCstService()
        await tabelaCstService.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tabcst', 'descricao_tabcst', false))
            options.push({ codigo_tabcst: null, descricao_tabcst: defaultEmptySelection() })
            setTabelaCsts(options)
        }).catch(err => errorToToast({ err, toast, alt: 'Não foi possível carregar as tabelas de CST.' }))
    }

    return (
        <FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>
                        <ControllerInput addClassName="md:col-12 lg:col-6 xl:col-4" field="descricao_tri" form={form} service={service} type="text" clearString label="Descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-2" field="sigla_tri" form={form} service={service} type="text" clearString label="Sigla" />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-2" field="cod_esf_tri" form={form} type="dropdown2" service={service} label="Esfera"
                            optionKey='codigo_esf'
                            optionLabel='descricao_esf'
                            options={esferas}
                            onLoad={loadEsferas}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-2" field="cod_tiptri_tri" form={form} type="dropdown2" service={service} label="Tipo de tributo"
                            optionKey='codigo_tiptri'
                            optionLabel='descricao_tiptri'
                            options={tipoTributos}
                            onLoad={loadTipoTributos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-3" field="cod_tabcst_tri" form={form} type="dropdown2" service={service} label="Tabela CST vinculada"
                            optionKey='codigo_tabcst'
                            optionLabel='descricao_tabcst'
                            options={tabelaCsts}
                            onLoad={loadTabelaCsts}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-3" field="cods_tiof_tri" form={form} service={service} type="text" clearString label="Tipos de operação (códigos)" placeholder="Ex.: 1,2,10" />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-3" field="campos_opefis_tri" form={form} service={service} type="text" clearString label="Campos de operação fiscal" placeholder="Ex.: campo1,campo2" />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-2" field="ini_vig_tri" form={form} service={service} type="calendar" label="Início da vigência" />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-2" field="fim_vig_tri" form={form} service={service} type="calendar" label="Fim da vigência" />
                        <ControllerInput addClassName="md:col-12" field="obs_tri" form={form} service={service} type="textarea" rows={4} autoResize label="Observação" />
                    </GridForm>

                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-2" field="serv_tri" form={form} service={service} type="switch" label="Incide sobre serviço" />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-2" field="merc_tri" form={form} service={service} type="switch" label="Incide sobre mercadoria" />
                        <ControllerInput addClassName="md:col-6 lg:col-3 xl:col-2" field="ativo_tri" form={form} service={service} type="switch" label="Ativo" />
                    </GridForm>

                </TabPanel>

                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
